import { Suspense, lazy } from 'react';

// Above-the-fold (LCP-critical): eager
import HeroSection from './home/sections/HeroSection';
import TrustStrip from './home/sections/TrustStrip';
import GulfSaudiSection from './home/sections/GulfSaudiSection';
import AboutSection from './home/sections/AboutSection';

// Below-the-fold: code-split for CWV (LCP / INP gains)
const EcosystemGateway       = lazy(() => import('@/components/ecosystem/EcosystemGateway'));
const SaudiWhiteCollarSection = lazy(() => import('./home/sections/SaudiWhiteCollarSection'));
const ServicesSection        = lazy(() => import('./home/sections/ServicesSection'));
const CountriesSection       = lazy(() => import('./home/sections/CountriesSection'));
const PopularGuidesSection   = lazy(() => import('./home/sections/PopularGuidesSection'));
const IndustriesSection      = lazy(() => import('./home/sections/IndustriesSection'));
const TestimonialsSection    = lazy(() => import('./home/sections/TestimonialsSection'));
const FinalCtaSection        = lazy(() => import('./home/sections/FinalCtaSection'));
const BrandFooterSection     = lazy(() => import('./home/sections/BrandFooterSection'));

// Skeleton — lightweight, CLS-stable placeholder for each lazy chunk.
const SectionSkeleton = ({ minHeight = 480 }) => (
  <div className="bg-slate-950" style={{ minHeight }} aria-hidden="true" />
);

const HomePage = () => {
  const openWhatsApp = () => {
    window.open(
      'https://wa.me/919958848998?text=Hello%20Zafco,%20I%20need%20help%20with%20overseas%20recruitment',
      '_blank',
    );
  };

  return (
    <div className="bg-slate-950 text-white overflow-hidden" data-testid="home-page">
      {/* Above the fold — eager */}
      <HeroSection onWhatsApp={openWhatsApp} />
      <TrustStrip />
      <GulfSaudiSection />
      <AboutSection />

      {/* Below the fold — lazy with CLS-stable skeletons */}
      <Suspense fallback={<SectionSkeleton minHeight={520} />}>
        <EcosystemGateway />
      </Suspense>
      {/* Premium-intent Saudi silo strip — segmented from the blue-collar
          GulfSaudiSection above. Drives equity into the 5 hub URLs and the
          /jobs/saudi-arabia-recruitment country trunk. */}
      <Suspense fallback={<SectionSkeleton minHeight={620} />}>
        <SaudiWhiteCollarSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton minHeight={640} />}>
        <ServicesSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton minHeight={560} />}>
        <CountriesSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton minHeight={720} />}>
        <PopularGuidesSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton minHeight={640} />}>
        <IndustriesSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton minHeight={520} />}>
        <TestimonialsSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton minHeight={680} />}>
        <FinalCtaSection onWhatsApp={openWhatsApp} />
      </Suspense>
      <Suspense fallback={<SectionSkeleton minHeight={240} />}>
        <BrandFooterSection />
      </Suspense>
    </div>
  );
};

export default HomePage;
